import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface PendingProps {
    children?: ReactNode
    tone?: 'light' | 'dark'
    className?: string
}

/** Marca un dato que FMG3D todavía debe confirmar (plazos, precios, número). Nunca se inventa. */
const Pending: FC<PendingProps> = ({ children = 'por confirmar', tone = 'light', className }) => {
    return (
        <span
            className={cn(
                'inline-flex items-center rounded-[0.35em] border border-dashed px-[0.4em] py-[0.05em] align-baseline',
                tone === 'light' ? 'border-foreground/45 bg-secondary text-foreground' : 'border-background/50 bg-background/10 text-background',
                className
            )}
        >
            <span className='sr-only'>Dato pendiente: </span>
            {children}
        </span>
    )
}

export default Pending
